import getValueFromQueryParams from "../utils/parse-query-params";

customElements.component = 'showroom-nav';

if (!customElements.get(customElements.component)) {
  const selectors = {
    nav: ".js-showroom-nav"
  };

  class ShowroomNav extends HTMLElement {
    constructor() {
      super();

      this.links = this.querySelectorAll("a");
      this.nav = document.querySelector(selectors.nav);
      this.lastScrollTop = 0;

      this.init();
      this.handleScroll = this.handleScroll.bind(this);

      window.addEventListener("popstate", this.init);
      window.addEventListener("scroll", this.handleScroll);
    }

    init() {
      const isPDP = window.location.pathname.includes("/products/");
      const isPLP = window.location.pathname.includes("/collections/");
      const showroomId = getValueFromQueryParams("id") || window.localStorage.getItem("last_viewed_showroom");

      if (showroomId) {
        this.nav.classList.remove("hidden");

        this.links.forEach(link => {
          const originalURL = link.getAttribute("href");

          link.setAttribute("href", `${originalURL}?id=${showroomId}`);
        });
      }

      if (isPDP || isPLP) {
        this.nav.classList.add("is-pdp");
      }
    }

    handleScroll() {
      if (window.innerWidth <= 768) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.nav.classList.contains("is-pdp")) {
          if (scrollTop > 50) {
            this.nav.classList.add("scrolled-down");
          } else {
            this.nav.classList.remove("scrolled-down");
          }
        }

        if (scrollTop > this.lastScrollTop) {
          this.nav.classList.add("scrolled");
        } else {
          this.nav.classList.remove("scrolled");
        }

        this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
      }
    }
  }

  customElements.define(customElements.component, ShowroomNav);
}
